export default {
  Copy: 'Copy',
  Copy_markdown: 'Copy markdown',
  Copy_Success: 'Copy Success',
  Regenerate: 'Regenerate',
  Download_image: 'Download image',
  Download_Markdown: 'Download Markdown',

  // exportRecord
  Cancel: 'Cancel',
  Select_all: 'Select all',
  messages_selected: 'messages selected',

  ask_answer: {
    title: 'Smart Converse, Create, Present',
    ppt_des: 'PowerPoint with Al',
    pdf_des: 'Articlas, Papers, Books',
    image_des: 'Instantly create Al images',
    upgrade: 'Subscribe to Pro or Unlimited',
    footer: '© Copyright 2026 Sunstack Limited. | All rights reserved'
  }
}
